export default {
    // businessLicense列表页
    businessLicenseShow: "/accountPayable/businessLicense/show",
    // businessLicense新增执照信息
    addBusinessLicense: "/accountPayable/businessLicense/addBusinessLicense",
    // businessLicense更新 执照过期日期
    updateExpirationDate: "/accountPayable/businessLicense/updateExpirationDate",
    // businessLicense推送账单
    businessLicenseMakePayment: "/accountPayable/businessLicense/makePayment",
    // businessLicense推送账单文件
    businessLicenseMakePaymentUpload: "/accountPayable/businessLicense/upload",
    // businessLicense展示历史附件
    businessLicenseDocumentHistory: "/accountPayable/businessLicense/documentHistory",
    // businessLicense获取各状态条数
    businessLicenseGetHead: "/accountPayable/businessLicense/getHead",
    // 导出businessLicense excel
    exportBusinessLicenseExcel: "/accountPayable/businessLicense/exportBusinessLicenseExcel",
    // businessLicense功能updateStatus 
    businessLicenseUpdateStatus: "/accountPayable/businessLicense/updateStatus",
    // businessLicense功能showInvoice
    businessLicenseShowInvoice: "/accountPayable/businessLicense/showInvoice",
    // businessLicense功能showPendingFile
    businessLicenseShowPendingFile: "/accountPayable/businessLicense/showPendingFile",
    // businessLicense逻辑删除
    businessLicenseDelete: "/accountPayable/businessLicense/delete",
    // glAcct下拉框
    businessLicenseGlAcctList: "/accountPayable/businessLicense/glAcctOption",
    // 通过propId获取prop以及对应下unit的详细信息
    businessLicensePropDetails: "/accountPayable/businessLicense/propDetails",
    // 根据propId获取unit详情列表
    businessLicensePropList: "/accountPayable/businessLicense/unitDetails",
};
